module.exports = __webpack_public_path__ + "img/kecheng.bdcdcb1d.png";